__turbopack_context__.v({
  "add": "teacher-calendar-timeline-module__Z56AUG__add",
  "booked": "teacher-calendar-timeline-module__Z56AUG__booked",
  "bookedDot": "teacher-calendar-timeline-module__Z56AUG__bookedDot",
  "bookingDialog": "teacher-calendar-timeline-module__Z56AUG__bookingDialog",
  "calendar": "teacher-calendar-timeline-module__Z56AUG__calendar",
  "closed": "teacher-calendar-timeline-module__Z56AUG__closed",
  "closedDot": "teacher-calendar-timeline-module__Z56AUG__closedDot",
  "date": "teacher-calendar-timeline-module__Z56AUG__date",
  "datePicker": "teacher-calendar-timeline-module__Z56AUG__datePicker",
  "dates": "teacher-calendar-timeline-module__Z56AUG__dates",
  "event": "teacher-calendar-timeline-module__Z56AUG__event",
  "events": "teacher-calendar-timeline-module__Z56AUG__events",
  "hour": "teacher-calendar-timeline-module__Z56AUG__hour",
  "month": "teacher-calendar-timeline-module__Z56AUG__month",
  "monthPicker": "teacher-calendar-timeline-module__Z56AUG__monthPicker",
  "next": "teacher-calendar-timeline-module__Z56AUG__next",
  "now": "teacher-calendar-timeline-module__Z56AUG__now",
  "openDot": "teacher-calendar-timeline-module__Z56AUG__openDot",
  "outside": "teacher-calendar-timeline-module__Z56AUG__outside",
  "previous": "teacher-calendar-timeline-module__Z56AUG__previous",
  "scroll": "teacher-calendar-timeline-module__Z56AUG__scroll",
  "short": "teacher-calendar-timeline-module__Z56AUG__short",
  "switch": "teacher-calendar-timeline-module__Z56AUG__switch",
  "timeline": "teacher-calendar-timeline-module__Z56AUG__timeline",
  "toolbar": "teacher-calendar-timeline-module__Z56AUG__toolbar",
  "weekday": "teacher-calendar-timeline-module__Z56AUG__weekday",
});
